import React from 'react'
import styles from './textArea.module.scss'
import cx from 'classnames'
import ErrorIcon from '../../../icons/errorIcon.svg'
import { useTranslation } from 'react-i18next'

const TextArea = ({
  textAreaMessage,
  label,
  validationMessage,
  required,
  marginBottom,
  ...props
}) => {
  const { t } = useTranslation()
  const errorMessage = Array.isArray(validationMessage)
    ? validationMessage.map((e) => t(e)).join(' ')
    : t(validationMessage)
  return (
    <div
      className={cx(styles.textAreaWrapper, {
        [styles.marginBottom]: marginBottom,
        [styles.textAreaMessage]: textAreaMessage,
      })}
    >
      <textarea
        className={cx(styles.textArea, {
          [styles.invalidInput]: validationMessage,
          [styles.textAreaMessage]: textAreaMessage,
        })}
        required
        {...props}
      />
      <label
        className={cx(styles.floatingLabel, {
          [styles.floatingLabelRequired]: required,
        })}
      >
        {label}
      </label>
      {validationMessage ? (
        <div className={styles.errorMessage}>
          <img src={ErrorIcon} alt={ErrorIcon} />
          <span>{errorMessage}</span>
        </div>
      ) : null}
    </div>
  )
}

export default TextArea
